import * as t from 'io-ts';
import { Authentication } from 'acscp/api/requests/core/baseRequest';
import { BasePostRequest } from 'acscp/api/requests/core/basePostRequest';
import { LocaleCode } from 'acscp/translations';

export class LanguageChangeRequest extends BasePostRequest<undefined> {
    constructor(public languageCode: LocaleCode) {
        super(
            `users/change-language`,
            {},
            {languageCode},
            t.undefined,
            Authentication.Login);
    }
}
